import { POI } from "../../types/poi.types";

export const MOCK_POIS: POI[] = [
    {
        id: '1',
        name: {
            it: 'Ingresso principale',
            en: 'Main entrance',
            fr: 'Entrée principale',
            de: 'Haupteingang'
        },
        type: 'meeting_point',
        position: { lt: 42.3052881101845, lg: 11.622973316927334 },
        description: {
            it: 'Punto di incontro del camping',
            en: 'Meeting point of the park',
            fr: 'Point de rencontre du parc',
            de: 'Treffpunkt des Parks'
        },
        meta: null
    },
    {
        id: '2',
        name: {
            it: 'Bagni',
            en: 'restrooms',
            fr: 'Toilettes',
            de: 'Toiletten'
        },
        type: 'restroom',
        position: { lt: 42.30297971564092, lg: 11.625679798183477 },
        description: {
            it: 'Servizi igienici pubblici',
            en: 'Public restroom facilities',
            fr: 'Installations sanitaires publiques',
            de: 'Öffentliche Sanitäranlagen'
        },
        meta: {
            updatedAt: new Date().getTime() - 5 * 60 * 1000, // 5 minutes ago
            isOperational: true,
        }
    },
    {
        id: '3',
        name: {
            it: 'Piscine',
            en: 'Swimming pool',
            fr: 'Swimming pool',
            de: 'Swimming pool'
        },
        type: 'swimming_pool',
        position: { lt: 42.30451200256159, lg: 11.622600696804914 },
        description: {
            it: 'Piscina con cascata e giochi',
            en: 'Piscina with waterfall and water games',
            fr: 'Piscina with waterfall and water games',
            de: 'Piscina with waterfall and water games'
        },
        meta: {
            capacity: 120,
            currentOccupancy: 65,
            temperature: 26,
        }
    },
    {
        id: '4',
        name: {
            it: 'Spiaggia',
            en: 'Beach',
            fr: 'Plage',
            de: 'Strand'
        },
        type: 'beach',
        position: { lt: 42.302055026479465, lg: 11.62117345704427 },
        description: {
            it: 'Spiaggia attrezzata con ombrelloni, lettini e servizio soccorso',
            en: 'Spiaggia attrezzata con ombrelloni, lettini e servizio soccorso',
            fr: 'Spiaggia attrezzata con ombrelloni, lettini e servizio soccorso',
            de: 'Spiaggia attrezzata con ombrelloni, lettini e servizio soccorso'
        },
        meta: {}
    }
];